import { useFormContext, useFormState, useWatch } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';
import CheckboxField from 'components/forms/checkboxField/CheckboxField';
import { TransLink } from 'components/text/TransLink';
import useFormatCurrency from 'hooks/useFormatCurrency';
import { Property } from 'models/Properties';
import {
  HOSTFULLY_ASSIST_PRIVACY_URL,
  HOSTFULLY_ASSIST_TERMS_URL,
  HOSTFULLY_ASSIST_CURRENCY,
} from './HostfullyAssistDetails.constants';
import { HostfullyAssistDetailsFormSchemaType } from './HostfullyAssistDetails.schema';
import {
  Agreements,
  Footnote,
  TryForFreeButton,
} from './HostfullyAssistDetails.styles';
import { getAssistTotalPrice } from './HostfullyAssistDetails.utils';

const AgreementsSection = ({
  isActivating,
  properties,
}: {
  isActivating: boolean;
  properties: Property[];
}) => {
  const { t } = useTranslation();
  const formatCurrency = useFormatCurrency();
  const { control } = useFormContext<HostfullyAssistDetailsFormSchemaType>();
  const { isSubmitting, isValid } = useFormState();

  const selectedProperties = useWatch({ control, name: 'selectedProperties' });

  return (
    <Agreements>
      <CheckboxField name="agreeToTerms" required>
        <Trans
          i18nKey="pageHostfullyAssist.details.agreements.terms"
          components={{
            link1: (
              <TransLink
                href={HOSTFULLY_ASSIST_TERMS_URL}
                target="_blank"
                rel="noreferrer"
              />
            ),
          }}
        />
      </CheckboxField>
      <CheckboxField name="agreeToPrivacy" required>
        <Trans
          i18nKey="pageHostfullyAssist.details.agreements.privacy"
          components={{
            link1: (
              <TransLink
                href={HOSTFULLY_ASSIST_PRIVACY_URL}
                target="_blank"
                rel="noreferrer"
              />
            ),
          }}
        />
      </CheckboxField>

      <TryForFreeButton
        type="submit"
        disabled={!isValid || isSubmitting || isActivating}
        data-testid="assist-details-try-for-free"
      >
        {t('pageHostfullyAssist.details.actions.tryForFree')}
      </TryForFreeButton>

      <Footnote data-testid="assist-details-footnote">
        {t('pageHostfullyAssist.details.footnote', {
          total: formatCurrency({
            value: getAssistTotalPrice(selectedProperties, properties),
            currency: HOSTFULLY_ASSIST_CURRENCY,
          }),
        })}
      </Footnote>
    </Agreements>
  );
};

export default AgreementsSection;
